import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { RiEqualizerLine } from 'react-icons/ri';
import { FaChevronDown } from 'react-icons/fa';
import { IoSearch } from 'react-icons/io5';
import './MidSearch.scss';
import { useNavigate } from 'react-router';
import SignInPopupHOC from '../../../pages/Login/hoc/SigninHoc';
import SignIn from '../../../pages/Login/Signin';
// import CustomAutoComplete from '../../../utils/CustomAutoComplete';
import DatePicker from 'react-datepicker';
import { ToastType, showToastMessage } from '../../../utils/ToastOptionCommon';
import { setSelectedUnit } from '../../../redux/slices/HomeSlice';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { dateFormatForBE } from '../../../utils/common';
import { NearBy, NearByOptions } from '../../../constants/NearBy';
import {
  dealPropertyType,
  dealType,
  dealTypeEnum,
  propertyType,
  proprertyPriceRange,
  sellProprertyPriceRange,
} from '../../../constants/Property';
import callBackendAPI from '../../../utils/callBackendAPI';
import { debounce } from 'lodash';
import Select from 'react-select';
import { isUserAuthenticated } from '../../../redux/slices/LoginSlice';

interface IProps {
  signInToggleHandler: () => void;
}
interface DropdownProps {
  isOpen: boolean;
  onItemClick: Dispatch<
    SetStateAction<{ Id: number; Name: string; Value: number }>
  >;
  items: Array<{ Id: number; Name: string; Value: number }>;
}

const Dropdown: React.FC<DropdownProps> = (props) => {
  return (
    <>
      {props.isOpen && (
        <div className="dropdown-content">
          {props?.items?.map((e) => (
            <p onClick={() => props.onItemClick(() => e)}>{e.Name}</p>
          ))}
        </div>
      )}
    </>
  );
};

function MyDropdown({ isOpen, toggleDropdown }: any) {
  return (
    <div className="dropdown">
      <div className="dropdown-btn" onClick={toggleDropdown}>
        {/* <FaChevronDown /> */}
      </div>
      {isOpen && <div className="dropdown-content"></div>}
    </div>
  );
}

const MidSearch: React.FC<IProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const isAuthenticated = useSelector(isUserAuthenticated);
  const { signInToggleHandler } = props;
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  // const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [locationSearch, setLocationSearch] = useState<any>({
    text: '',
    state: '',
    city: '',
    street: '',
    value: '',
    label: '',
  });
  const [results, setResults] = useState<any>([]);
  const [placeDetails, setPlaceDetails] = useState<any>({});
  const [emptyStringError, setEmptyStringError] = useState<boolean>(false);
  const [priceRange, setPriceRange] = useState<{
    Id: number;
    Name: string;
    MaxValue: number | undefined;
    MinValue: number | undefined;
  }>({ Id: 1, Name: 'No Price', MaxValue: 99999999, MinValue: 0 });
  const [selectedDealType, setSelectedDealType] = useState<{
    id: number;
    label: string;
    value: string;
  }>(dealType[0]);
  // const [maxPriceRange, setMaxPriceRange] = useState<{ Id: number, Name: string, Value: number }>({ Id: 1, Name: "10,000", Value: 10000 });
  // const [propertyType, setPropertyType] = useState<{
  //   Id: number;
  //   Name: string;
  //   Value: number;
  // }>({ Id: 1, Name: 'Room', Value: 1 });
  // const [nearByType, setnearByType] = useState(NearByOptions[0]);

  // const [moveInDate, setmoveInDate] = useState(new Date());
  // const [isMoveInOpen, setIsMoveInOpen] = useState(false);
  // const [isMoveOutOpen, setIsMoveOutOpen] = useState(false);
  // const [moveOutDate, setmoveOutDate] = useState(new Date());
  // const toggleAllDropdowns = () => {
  //     setIsDropdownOpen((isDropdownOpen) => !isDropdownOpen)
  // };
  // const nearByTypeList = [...NearByOptions];
  const selectedProperty = useSelector((state: any) => state.home.selectedUnit);

  const searchHandler = () => {
    // if (isAuthenticated) {
    if (locationSearch.text && locationSearch.text !== '') {
      navigate(`/search-properties`, {
        state: {
          dealType: selectedDealType.value,
          locationSearch: locationSearch,
          searchText: locationSearch.text,
          state: locationSearch.state,
          city: locationSearch.city,
          street: locationSearch.street,
          // place: placeDetails,
          propertyType: selectedProperty.value,
          minRoomPrice: priceRange.MinValue,
          maxRoomPrice: priceRange.MaxValue,
          // nearBy: nearByType.value,
          // moveIn: moment(moveInDate).format(dateFormatForBE),
          // moveOut: moment(moveOutDate).format(dateFormatForBE),
          price: priceRange.Id,
        },
      });
    } else {
      setEmptyStringError(() => true);
      showToastMessage('Please enter a valid loaction', ToastType.Info);
    }
    // } else {
    //   signInToggleHandler();
    // }
  };

  const locationSearchHandler: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    setLocationSearch(() => e.target.value);
  };

  const [areDropdownsOpen, setAreDropdownsOpen] = useState(false);

  const toggleAllDropdowns = () => {
    setAreDropdownsOpen(!areDropdownsOpen);
  };

  useEffect(() => {
    if (locationSearch) {
      setEmptyStringError(() => false);
    }
  }, [locationSearch, setEmptyStringError]);

  useEffect(() => {
    dispatch(setSelectedUnit({ unit: propertyType[0] }));
  }, []);

  const fetchAddresses = useCallback(
    debounce(async () => {
      if (!search) {
        setResults([]);
        return;
      }
      try {
        setLoading(true);
        const res = await callBackendAPI(
          'GET',
          `properties/search?q=${search}`
        );
        const data = res?.data?.map((e: any) => {
          return {
            value: e?.id,
            label: e?.address,
            state: e?.state,
            city: e?.city,
            street: e?.street,
          };
        });
        setResults(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, 500), // 400ms debounce
    [search]
  );

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  return (
    <>
      <div className="hero-home-search">
        <div className="row mx-0 w-100">
          <div className="col-sm-6 col-md-2 col-sm-6 mb-3">
            <label htmlFor="dealType">Deal Type</label>
            <select
              id="dealType"
              className="form-select"
              value={selectedDealType.id}
              onChange={(e) => {
                let selected = dealType
                  ?.filter((data) => Number(e.target.value) === data.id)
                  ?.map((e) => e);

                if (!selected[0]) return;

                if (selected[0].value === dealTypeEnum.Sell) {
                  showToastMessage(
                    'We will launch this facility soon.',
                    ToastType.Info
                  );
                  setSelectedDealType(dealType[0]);
                  e.target.value = String(dealType[0].id);
                  return;
                }

                setSelectedDealType(selected[0]);
                dispatch(setSelectedUnit({ unit: propertyType[0] }));
              }}
            >
              {dealType?.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.searchLabel}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6 col-md-4 col-sm-6 mb-3">
            <label>Location</label>
            <Select
              options={results}
              placeholder="Enter location..."
              aria-label="Location"
              onInputChange={(e: any) => {
                if (e.length >= 3) {
                  setSearch(e); // trigger API call
                }
              }}
              onChange={(e: any) =>
                setLocationSearch({
                  text: e.label,
                  state: e.state,
                  city: e.city,
                  street: e.street,
                  label: e.label,
                  value: e.value,
                })
              }
              isLoading={loading}
              menuPortalTarget={document.body} // render menu outside container
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              noOptionsMessage={({ inputValue }) =>
                inputValue.length === 0
                  ? 'Search location'
                  : 'Looks like we don’t have listings here yet.'
              }
            />
            {/* <input
              className="form-control"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            /> */}
            {/* <CustomAutoComplete
              id={emptyStringError ? `search-input-error` : ''}
              value={locationSearch}
              setValue={setLocationSearch}
              setPlaceDetails={setPlaceDetails}
            /> */}
          </div>

          <div className="col-sm-6 col-md-3 col-sm-6 mb-3">
            <label htmlFor="propertyType">I'm looking for...</label>
            <select
              id="propertyType"
              className="form-select"
              value={selectedProperty.Id}
              onChange={(e) => {
                const allTypes =
                  selectedDealType.value === dealTypeEnum.Sell
                    ? dealPropertyType
                    : propertyType;
                let selected = allTypes
                  ?.filter((data) => Number(e.target.value) === data.id)
                  ?.map((e) => e);
                dispatch(setSelectedUnit({ unit: selected[0] }));
              }}
            >
              {selectedDealType.value === dealTypeEnum.Sell
                ? dealPropertyType?.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.label}
                    </option>
                  ))
                : propertyType?.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.label}
                    </option>
                  ))}
            </select>
          </div>
          <div className="col-sm-6 col-md-3 col-sm-6 mb-3">
            <label htmlFor="priceRange">Price Range</label>
            <select
              id="priceRange"
              className="form-select"
              onChange={(e) => {
                setPriceRange(() => {
                  const allRanges =
                    selectedDealType.value === dealTypeEnum.Sell
                      ? sellProprertyPriceRange
                      : proprertyPriceRange;
                  let selected = allRanges
                    ?.filter((data) => Number(e.target.value) === data.Id)
                    ?.map((e) => e);
                  return selected[0];
                });
              }}
            >
              {selectedDealType.value === dealTypeEnum.Sell
                ? sellProprertyPriceRange?.map((e) => (
                    <option key={e.Id} value={e.Id}>
                      {e.Name}
                    </option>
                  ))
                : proprertyPriceRange?.map((e) => (
                    <option key={e.Id} value={e.Id}>
                      {e.Name}
                    </option>
                  ))}
            </select>
          </div>

          {/* <div className="col-sm-6 col-md-4 col-sm-6 mb-3">
            <label>Move In</label>
            <DatePicker
              id="date-move-in"
              // open={isMoveInOpen}
              selected={moveInDate}
              onInputClick={() => {
                setIsMoveInOpen(() => true);
              }}
              minDate={new Date()}
              onChange={(date: Date) => {
                console.log(date);
                setmoveInDate(() => date);
              }}
              onClickOutside={() => {
                setIsMoveInOpen((isOpen) => !isOpen);
              }}
              onSelect={(date: Date) => {
                console.log(date);
                setmoveInDate(() => date);
                setIsMoveInOpen((isOpen) => !isOpen);
              }}
              dateFormat="MM/dd/yyyy"
              dropdownMode="select"
              placeholderText=""
              className="form-control"
            />
          </div>

          <div className="col-sm-6 col-md-4 col-sm-6 mb-3">
            <label>Move Out</label>
            <DatePicker
              id="date-move-out"
              open={isMoveOutOpen}
              selected={moveOutDate}
              onInputClick={() => {
                setIsMoveOutOpen(() => true);
              }}
              minDate={new Date()}
              onChange={(date: Date) => {
                setmoveOutDate(() => date);
              }}
              onClickOutside={() => {
                setIsMoveOutOpen((isOpen) => !isOpen);
              }}
              onSelect={(date: Date) => {
                setmoveOutDate(() => date);
                setIsMoveOutOpen((isOpen) => !isOpen);
              }}
              dateFormat="MM/dd/yyyy"
              dropdownMode="select"
              placeholderText=""
              className="form-control"
            />
          </div>

          <div className="col-sm-6 col-md-4 col-sm-6 mb-3">
            <label>Near By</label>
            <select
              className="form-select"
              onChange={(e) => {
                setnearByType((): any => {
                  //let selected = nearByTypeList.filter((data) => Number(e.target.value) === data.Id)?.map(e => e);
                  let selected = nearByTypeList.find(
                    (data) => e.target.value === data.value
                  );
                  return selected;
                });
              }}
            >
              {nearByTypeList?.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
          </div> */}

          <div className="col-12 d-flex justify-content-center align-items-center">
            <button
              className="btn btn-primary focus-btn"
              onClick={searchHandler}
            >
              {/* <IoSearch className="w-5 h-5" /> */}
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MidSearch;
